<template>
  <div class="Multiple">
    <v-layout wrap align-start justify-center row fill-height>
      <v-flex xs12 :lg6="data.length <= graphLimit" class="hidden-md-and-down">
        <v-card>
          <v-card-title class="title">
            <v-spacer/>

            <v-card-actions>
              <v-spacer/>
              <v-btn color="info" :disabled="dataVals === null">
                <download-csv
                  :data="datosCSV"
                  :name="csvname + '.csv'"
                  :labels="labels"
                  :fields="fields"
                >
                  <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                </download-csv>
              </v-btn>
            </v-card-actions>
          </v-card-title>

          <v-card-text v-html="questionsShow">
          </v-card-text>

          <v-card-text>
            <data-table
              :headers="headers"
              :dataVals="dataVals"
              :searchActive="true"
              :key="tableKey"
              disable-initial-sort
            />
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 lg6 v-if="data.length <= graphLimit || breakpoint">
        <v-card>
          <v-tabs
            v-model="tabs"
            fixed-tabs
            color="transparent"
            slider-color="iK"
            :key="tabsKey"
          >
            <v-tab :key="table" ripple v-if="breakpoint">
              <v-icon color="info">table_chart</v-icon>
            </v-tab>
            <v-tab :key="bar" ripple v-if="data.length < graphLimit">
              <v-icon color="info">bar_chart</v-icon>
            </v-tab>
            <v-tab :key="pie" ripple v-if="data.length < graphLimit">
              <v-icon color="info">pie_chart</v-icon>
            </v-tab>

            <v-tab-item :key="table" v-if="breakpoint">
              <v-card-actions>
                <v-spacer/>
                <v-btn color="info" :disabled="dataVals === null">
                  <download-csv
                    :data="datosCSV"
                    :name="csvname"
                    :labels="labels"
                    :fields="fields"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>

              <v-card-text>
                <data-table
                  :headers="headers"
                  :dataVals="dataVals"
                  :searchActive="true"
                  :key="tableKey"
                  disable-initial-sort
                ></data-table>
              </v-card-text>
            </v-tab-item>

            <v-tab-item :key="bar" v-if="data.length < graphLimit">
              <v-card-text>
                <chart-column
                  :chartOptions="chartOptions"
                  :chartSeries="chartSeries"
                  :key="chartKey"
                />
              </v-card-text>
            </v-tab-item>

            <v-tab-item :key="pie" v-if="data.length < graphLimit">
              <v-flex md10 lg12>
                <v-card-text>
                  <pie-chart
                    :chartOptions="pieOptions"
                    :chartSeries="pieSeries"
                    :key="pieKey"
                  />
                </v-card-text>
              </v-flex>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import JsonCSV from 'vue-json-csv'
import chartColumn from '@/components/Charts/ColumnBase'
import pieChart from '@/components/Charts/PieBase'
import dataTable from '@/components/Tables/TableWithTotals'

export default {
  name: 'Multiple',

  components: {
    'download-csv': JsonCSV,
    'chart-column': chartColumn,
    'pie-chart': pieChart,
    'data-table': dataTable
  },

  /**
   * Elementos que recibe el componente para renderizar
   */
  props: {
    /** Datos a procesar y mostrar */
    data: {
      type: Array,
      required: true
    },
    /** Nombre del CSV */
    csvname: {
      type: String,
      required: true
    },
    /** Información de las preguntas */
    questionsShow: {
      type: String,
      required: true
    }
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.processData()
  },

  data: function () {
    return {
      tabsKey: 0,
      graphLimit: 21,

      pieOptions: {
        chart: {
          type: 'pie'
        },
        labels: [],
        colors: [
          '#4177A6', '#41A66C', '#D94E5A', '#F2C53D', '#df040b', '#59A8D9',
          '#b3b2b2', '#f9b233',
          '#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#00D9E9',
          '#FF66C3', '#546E7A', '#26a69a', '#D10CE8', '#E91E63', '#FF9800',
          '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6', '#18D8D8',
          '#A9D794', '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD',
          '#7A918D', '#BAFF29'
        ],

        // plotOptions: {
        //   pie: {
        //     customScale: 0.8
        //   }
        // },
        // theme: {
        //   monochrome: {
        //     color: '#FF4560',
        //     enabled: true
        //   }
        // },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center'
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'middle',
          // formatter: function (val) {
          //   return Number.parseFloat(val).toFixed(3) + "%"
          // },
          style: {
            fontSize: '14px'
          }
        },
        responsive: [{
          breakpoint: 721,
          options: {
            chart: {
              height: 450
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      pieSeries: null,

      chartOptions: {
        chart: {
          type: 'bar',
          height: 350
        },
        colors: [
          '#4177A6', '#41A66C', '#D94E5A', '#F2C53D', '#df040b', '#59A8D9',
          '#b3b2b2', '#f9b233',
          '#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#00D9E9',
          '#FF66C3', '#546E7A', '#26a69a', '#D10CE8', '#E91E63', '#FF9800',
          '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6', '#18D8D8',
          '#A9D794', '#46AF78', '#A93F55', '#8C5E58', '#2176FF', '#33A1FD',
          '#7A918D', '#BAFF29'
        ],

        plotOptions: {
          bar: {
            // horizontal: true,
            distributed: true,
            dataLabels: {
              position: 'top' // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '14px',
            colors: ['#304758']
          }
        },

        xaxis: {
          categories: [],
          title: {
            text: 'Opción'
          },
          labels: {
            show: false,
            style: {
              fontSize: '14px'
            }
          }
        },
        yaxis: {
          title: {
            text: 'Número de Encuestas'
          }
        },
        legend: {
          position: 'bottom',
          offsetY: -7
        },
        fill: {
          opacity: 1
        },
        responsive: [{
          breakpoint: 721,
          options: {
            chart: {
              height: 450
            },
            legend: {
              position: 'bottom',
              offsetY: -7
            },
            xaxis: {
              labels: {
                show: false
              }
            }
          }
        }]
      },
      chartSeries: [
        {
          name: 'Encuestas',
          data: null
        }
      ],

      headers: [],
      labels: {},
      fields: [],
      dataVals: [],

      datosCSV: [],

      chartKey: 0,
      pieKey: 0,
      tableKey: 0
    }
  },

  computed: {
    /**
     * Determina el valor del breakpoint para renderizar elementos a conveniencia
     * @return {boolean} Truo o Flase segun el elemento
     */
    breakpoint () {
      switch (this.$vuetify.breakpoint.name) {
        case 'lg': return false
        case 'xl': return false
        default: return true
      }
    },

    /**
     * Determina la pestaña principal
     * @return {String} Pestaña a mostar
     */
    tabs () {
      return this.breakpoint ? 'table' : 'bar'
    }
  },

  methods: {
    /**
     * Procesa los datos de la pregunta, y los formatea
     * para ser visualizados en tabla, barras y torta
     */
    processData () {
      let lab = [] // labels
      let ser = [] // totales
      let cant = [] // datos para tabla
      let cont = 0

      let cant2 = [] // datos para el csv

      if (this.data.length > 0) {
        // obtiene el total para calcular los porcentajes
        this.data.forEach(function (element) {
          cont += element.total
        })

        // calcualr el porcentaje y formatea los datos
        this.data.forEach(function (element) {
          let keys = Object.keys(element)
          let perc = element.total / cont * 100
          perc = Number.parseFloat(perc).toFixed(1) + ' %'

          ser.push(element.total)

          let obj = {}
          let obj2 = {}
          let quests = []
          keys.pop()

          keys.forEach(function (k) {
            if (element[k].url) {
              obj2[k] = element[k].url
            } else {
              obj2[k] = element[k]
            }
            quests.push(element[k])
            obj[k] = element[k]
          })
          obj['total'] = element.total
          obj['percentage'] = perc
          obj2['total'] = element.total
          obj2['percentage'] = perc

          lab.push(quests.join(', '))
          cant.push(obj)
          cant2.push(obj2)
        })
      }

      this.dataVals = cant // Guarda los datos de la tabla
      this.datosCSV = cant2 // Guarda los datos para el csv

      if (this.data.length > 0) {
        this.updateTable()
      }

      this.tableKey += 1

      this.pieOptions.labels = lab
      this.pieSeries = ser

      this.chartOptions.xaxis.categories = lab
      this.chartSeries[0].data = ser

      this.pieKey += 1
      this.chartKey += 1
    },

    /**
     * Función que actualiza los datos de headers de la tabla
     */
    updateTable () {
      let keys = Object.keys(this.data[0])
      keys.pop()

      let head = []
      let labs = []

      keys.forEach(function (k, index) {
        head.push(
          { text: k, value: k, str: ' ' }
        )
        labs[k] = k
      })
      head[head.length - 1].str = 'Total'
      head.push(
        { text: 'Total', value: 'total', align: 'center' },
        { text: 'Porcentaje', value: 'percentage', align: 'center', str: ' ' }
      )
      labs.total = 'Respuestas'
      labs.percentage = 'Porcentaje'

      this.headers = head
      this.labels = labs

      this.fields = Object.keys(this.dataVals[0])
    }
  }
}
</script>
